<template>
  <div class="title-wrapper">
    <el-tabs v-model="active_name">
      <el-tab-pane label="选择标题" name="choose_title">
        <auxiliary-title ref="choose_title_ref" scene="ChooseTitle" :scene-props="scene_props" @hook:mounted="onTableMounted" />
      </el-tab-pane>
      <el-tab-pane label="批量上传" name="upload_title">
        <auxiliary-title ref="upload_title_ref" scene="UploadTitle" :scene-props="scene_props" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { isNotNullAndUnDef } from '@/utils/is';

export default {
  components: {
    'auxiliary-title': () => import('@/views/auxiliary/title/index.vue'),
  },
  props: {
    // 渠道接口
    channelInterface: {
      type: String,
      required: true,
    },
    // 已选中的标题值
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      active_name: 'choose_title', // 当前tabs活跃的面板
    };
  },
  computed: {
    /**
     * 场景的数据
     * @returns {Object} 传递给`auxiliary-title`组件的props数据
     */
    scene_props() {
      return {
        permissions: `title-list-${this.channelInterface}`,
      };
    },
  },
  methods: {
    /**
     * 获取分配数据
     * @returns {Array} 标题对象数组或空数组
     */
    async getAssignSelection() {
      try {
        const ref = this.$refs[`${this.active_name}_ref`];
        if (ref.getAssignSelection) {
          return await ref.getAssignSelection();
        }
        const refs = this.$refs[`${this.active_name}_ref`].$children;
        return await refs[0].getAssignSelection();
      } catch (error){
        console.error(error);
        return [];
      }
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      /**
       * 排除不存在ID值的数据项 - 上传的标题没有ID
       * 排除标题组件的数据项 - 广点通引用的媒体标题组件
       */
      const list = this.value.filter(({ id, title_component_type = '' }) => {
        return isNotNullAndUnDef(id) && title_component_type !== 'component';
      });
      const [ref] = this.$refs[`${this.active_name}_ref`].$children;
      const app_table_ref = ref.$refs.table;
      ref.multiple_selection.splice(0);
      ref.multiple_selection.push(...list);
      app_table_ref.multipleSelection.splice(0);
      app_table_ref.multipleSelection.push(...ref.multiple_selection);
      app_table_ref.multipleSelectionAll.splice(0);
      app_table_ref.multipleSelectionAll.push(...ref.multiple_selection);
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      setTimeout(this.initRowsSelection.bind(this), 0);
    },
  },
};
</script>
